module.exports = require("chalk");


//////////////////
// WEBPACK FOOTER
// external "chalk"
// module id = 3
// module chunks = 0